/**
 * 用于存储登录状态
 */
import {CHECK_AUTHENTICATION, OBTAIN_AUTHENTICATION, CLEAR_AUTHENTICATION} from '../mutation-types'

const state = {
  authenticated: false,
  header: ''
}

const mutations = {
  [CHECK_AUTHENTICATION] (state) {
    state.authenticated = !!localStorage.getItem('home_token')
    if (state.authenticated) {
      state.header = `Bearer ${localStorage.getItem('home_token')}`
    }
  },
  [OBTAIN_AUTHENTICATION] (state, token) {
    state.authenticated = true
    localStorage.setItem('home_token', token)
    state.header = `Bearer ${token}`
  },

  [CLEAR_AUTHENTICATION] (state) {
    state.authenticated = false
    localStorage.removeItem('home_token')
    state.header = ''
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js